export default __webpack_public_path__ + "static/media/whatsapp_icon.4809d603.svg";